import axios from 'axios'

const TICKET_URL = `${process.env.REACT_APP_API_URL}/ticket`

export type FreshDeskCreateTicketResponse = {
  freshDeskId: string
  subject: string
}

export type FreshDeskTicketReporterOption = {
  email: string
  fullName: string
}

export const getFreshDeskTicketReporterOptions = async () => {
  return axios.get<FreshDeskTicketReporterOption[]>(`${TICKET_URL}/reporter-options`)
}

export const createGenericFreshDeskTicket = async (payload: {
  subject: string
  body: string
  requesterEmail: string
  requesterName: string
  assignedReporterEmail?: string
  attachments?: File[]
}) => {
  const formData = new FormData()
  formData.append('subject', payload.subject)
  formData.append('body', payload.body)
  formData.append('requesterEmail', payload.requesterEmail)
  formData.append('requesterName', payload.requesterName)

  if (payload.assignedReporterEmail) {
    formData.append('assignedReporterEmail', payload.assignedReporterEmail)
  }

  for (const attachment of payload.attachments ?? []) {
    formData.append('attachments', attachment)
  }

  return axios.post<FreshDeskCreateTicketResponse>(`${TICKET_URL}/create`, formData)
}
